'use client'

import React, {useContext} from 'react'
import {ProductListItemViewModel} from '@/src/presentation'
import {getInjection} from '@runlab/di'
import {Product} from '@/src/core/domain/entities/product'

const Context = React.createContext<ProductListItemViewModel | null>(null)

export const ProductListItemProvider = ({
  children,
  product,
}: React.PropsWithChildren & {product: Product}) => {
  const productListItemVM = getInjection('ProductListItemViewModelFactory')(product)

  return <Context value={productListItemVM}>{children}</Context>
}

export const useProductListItem = () => {
  const vm = useContext(Context)

  if (!vm) throw Error('ProductListItemProvider not wrapped with')

  return vm
}
